import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门文章
            </h2>
            <p className="text-sm text-foreground-500">社区最受关注的技术文章精选</p>
          </div>
          <Link
            to="/category/programming"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer block"
            >
              <div className="flex gap-4">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden shrink-0">
                  <img
                    src={article.thumbImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-eye-line text-xs"></i>
                      </span>
                      {article.readCount.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-chat-3-line text-xs"></i>
                      </span>
                      {article.commentCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-heart-line text-xs"></i>
                      </span>
                      {article.likeCount}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/programming"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部热门文章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}